<template>
  <div v-if="list_type">
    <v-card-text style="height: 532px; overflow-y: auto;">
      <v-layout row wrap>
        <v-flex xs6 pr-1>
          <v-text-field v-model="list_type.name" label="Name"></v-text-field>


           <v-select label="Upload config" :items="upload_configurations" v-model="list_type.meta.upload_config" item-text="name" item-value="name">
           </v-select>

        </v-flex>
        <v-flex xs6 pl-1>
          Fields:
          <json-editor v-model="list_type.fields" v-if="list_type.fields"></json-editor>
        </v-flex>
      </v-layout>

    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="reset">Reset</v-btn>
      <v-btn color="success" @click="save(false)">Save</v-btn>
      <v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
export default {
  props: ['id'],
  components: {
    JsonEditor
  },
  data() {
    var ch = this.$cloudserver.channel((typeof(this.id) == "undefined" ? "cms:list_type:create" : "cms:list_type:" + this.id));
    return {
      ws_channel: ch,
      list_type: this.convert(ch.data),
    };
  },
  watch: {
    'ws_channel.data': {
      handler(val) {
        this.list_type = this.convert(val)
      },
      deep: true
    }
  },
  computed: {
    upload_configurations () {
      var ret = _.filter(this.$store.state.settings, (val, id) => {
        return val.type == "file_upload";
      })
      return ret;
    }
  },
  created() {
    this.ws_channel.join();
  },
  methods: {
    convert (val) {
      return _.cloneDeep(val.list_type);
    },
    reset() {
      console.log(this.ws_channel);
      this.list_type = this.convert(this.ws_channel.data);
    },
    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
        var send_list_type = _.cloneDeep(this.list_type);
         console.log("Saving", send_list_type);
        this.ws_channel.push("save", {list_type: send_list_type})
          .receive("ok", (msg) => {
            if (typeof(self.id) == "undefined") {
              self.$message.success("List type was created!");
            } else {
              self.$message.success("List type was updated!");
            }
            if(close) this.$root.close_bottom_sheet()
          })
          .receive("error", (msg) => {
            console.log(msg);
            if (typeof(self.id) == "undefined") {
              self.$message.warning("Unable to create list type!");
            } else {
              self.$message.warning("Unable to update list type!");
            }
          });
      }
    }
  }
}
</script>
